'use client';

/* -------------------------------------------------------------------------- */
/*                                Dependencies                                */
/* -------------------------------------------------------------------------- */

// Lib dependencies
import omit from 'lodash/omit';
import { modals } from '@mantine/modals';

// Types
import { PROMPT_BASE_PRESETS } from '../presets';

// Style
import * as classes from '../styles.css';
import Prompt from '../Prompt';
import { PromptConfirmArgs } from './types';

let modalNextId = 1;

const invokePromptConfirm = ({
  componentProps,
  ...args
}: PromptConfirmArgs) => {
  const modalId = `prompt:confirm:${(modalNextId += 1)}`;
  const color = 'blackroomOrange';

  modals.open({
    ...PROMPT_BASE_PRESETS,
    modalId,
    withCloseButton: false,
    classNames: {
      body: classes.body,
    },
    children: componentProps.modalContent ? (
      <Prompt
        color={color}
        modalId={modalId}
        onConfirm={args.onConfirm}
        {...componentProps}
      >
        {componentProps.modalContent}
      </Prompt>
    ) : (
      <Prompt
        color={color}
        modalId={modalId}
        onConfirm={args.onConfirm}
        i18nKey={
          componentProps.headless
            ? 'Common:prompts.promptConfirm.promptHeadless'
            : 'Common:prompts.promptConfirm.prompt'
        }
        i18nValues={{ entityLabel: componentProps.entityLabel }}
        {...componentProps}
      />
    ),
    trapFocus: false,
    ...omit(args, 'onConfirm'),
  });
};

export default invokePromptConfirm;
